// Spray

// ___________________________________________________________________

import * as React from 'react'
import styled from 'styled-components'
import theme from '../../gatsby-plugin-theme-ui'

// ___________________________________________________________________

const Spray = () => (
  <SVG viewBox="0 0 82.02 63.88">
    <title>Rotation icon</title>
    <path d="M29.09,63.65V52.14l-2.15.47v-1.1l2.68-1.16h1.09v13.3Z" />
    <path d="M34.83,63.65V52.14l-2.15.47v-1.1l2.68-1.16h1.08v13.3Z" />
    <path d="M44.44,63.88a5.31,5.31,0,0,1-3-.87,5.47,5.47,0,0,1-2-2.41,9.74,9.74,0,0,1,0-7.2,5.47,5.47,0,0,1,2-2.41,5.31,5.31,0,0,1,3-.87,5.25,5.25,0,0,1,3,.87,5.53,5.53,0,0,1,2,2.41,9.87,9.87,0,0,1,0,7.2,5.53,5.53,0,0,1-2,2.41A5.25,5.25,0,0,1,44.44,63.88Zm0-1.41a3.54,3.54,0,0,0,2.08-.65A4.35,4.35,0,0,0,48,59.94a8.54,8.54,0,0,0,0-5.87,4.32,4.32,0,0,0-1.45-1.87,3.67,3.67,0,0,0-4.17,0,4.37,4.37,0,0,0-1.44,1.87,8.39,8.39,0,0,0,0,5.87,4.41,4.41,0,0,0,1.44,1.88A3.55,3.55,0,0,0,44.44,62.47Z" />
    <path d="M56.6,53.09a2.51,2.51,0,0,1-2.55,2.54,2.41,2.41,0,0,1-2.48-2.45,2.51,2.51,0,0,1,2.54-2.56A2.41,2.41,0,0,1,56.6,53.09Zm-4,.09a1.49,1.49,0,0,0,1.48,1.56,1.53,1.53,0,0,0,1.51-1.63,1.5,1.5,0,0,0-1.53-1.6A1.54,1.54,0,0,0,52.59,53.18Z" />

    <path className="cls-1" d="M81.27,41l-.35-.35" />

    <path className="cls-2" d="M78,37.73,42.83,2.57" />

    <path className="cls-1" d="M41.36,1.1,41,.75l-.35.35" />

    <line className="cls-3" x1="37.73" y1="4.03" x2="2.57" y2="39.19" />

    <line className="cls-1" x1="1.1" y1="40.66" x2="0.75" y2="41.01" />

    <path className="cls-1" d="M48.41,41l-.09-.49" />

    <path className="cls-4" d="M47.58,36.49,41.47,3.25" />

    <path className="cls-1" d="M41.1,1.24,41,.75l-.09.49" />

    <line className="cls-5" x1="40.18" y1="5.27" x2="34.06" y2="38.5" />

    <line className="cls-1" x1="33.69" y1="40.52" x2="33.6" y2="41.01" />

    <path className="cls-1" d="M63.44,41l-.24-.43" />

    <path className="cls-6" d="M61.21,37l-19-34" />

    <path className="cls-1" d="M41.25,1.18,41,.75l-.24.44" />

    <line className="cls-7" x1="38.77" y1="4.77" x2="19.82" y2="38.78" />

    <line className="cls-1" x1="18.82" y1="40.57" x2="18.58" y2="41.01" />
  </SVG>
)

export default Spray

const SVG = styled.svg`
  .cls-1,
  .cls-2,
  .cls-3,
  .cls-4,
  .cls-5,
  .cls-6,
  .cls-7 {
    fill: none;
    stroke: #000;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
  }

  .cls-2 {
    stroke-dasharray: 1.04 4.14;
  }
  .cls-3 {
    stroke-dasharray: 1.04 4.14;
  }
  .cls-4 {
    stroke-dasharray: 1.02 4.1;
  }
  .cls-5 {
    stroke-dasharray: 1.02 4.1;
  }
  .cls-6 {
    stroke-dasharray: 1.02 4.1;
  }
  .cls-7 {
    stroke-dasharray: 1.02 4.1;
  }
`
